import React from 'react';

import { MultiSelect } from '@metarouter-private/mr-mui';

import useEventDebuggerPipelineSelectProps from './useEventDebuggerPipelineSelectProps';

export default function EventDebuggerPipelineSelect() {
  const props = useEventDebuggerPipelineSelectProps();
  return <MultiSelect {...props} />;
}
